<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M6.25 14.5H4C3.58579 14.5 3.25 14.1642 3.25 13.75V6.25C3.25 5.83579 3.58579 5.5 4 5.5H6.25" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13 4H7C6.58579 4 6.25 4.33579 6.25 4.75V15.25C6.25 15.6642 6.58579 16 7 16H13C13.4142 16 13.75 15.6642 13.75 15.25V4.75C13.75 4.33579 13.4142 4 13 4Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.75 5.5H16C16.4142 5.5 16.75 5.83579 16.75 6.25V13.75C16.75 14.1642 16.4142 14.5 16 14.5H13.75" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'AdsCarouselIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>